// import { darken } from 'polished';
import styled from 'styled-components';

export const Model1 = styled.div`
    height: 100%;
    display: flex;
    background-color: ${props => {
        const { colors, defColors } = props;
        const c =
            colors && colors.background
                ? colors.background
                : defColors.background;
        return c;
    }};

    .body {
        display: flex;
        flex: 1;
        flex-direction: column;
        align-self: stretch;
    }

    .img-area {
        height: 35%;
        display: flex;
        align-items: center;
        justify-content: center;

        .full-height {
            flex: 1;
            max-width: 50%;
            display: flex;
            align-self: stretch;
            align-items: center;
            justify-content: center;
        }

        img {
            max-height: 100%;
            object-fit: cover;
            width: ${props => {
                const parameters = (props && props.parameters) || {};
                const img_width = parameters.media_width || 0;
                const w = img_width;
                return w <= 100 ? `${w}%` : '100%';
            }};
        }
    }

    .options-area {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${props => {
            const { colors, defColors } = props;
            const c =
                colors && colors.button_text
                    ? colors.button_text
                    : defColors.button_text;
            return c;
        }};

        .full-height {
            flex: 1;
            align-self: stretch;
        }

        .option {
            text-align: center;
            height: 100%;
            border-radius: 2px;
            border: 1px solid
                ${props => {
                    const { colors, defColors } = props;
                    const c =
                        colors && colors.button_border
                            ? colors.button_border
                            : defColors.button_border;
                    return c;
                }};
            background-color: ${props => {
                const { colors, defColors } = props;
                const c =
                    colors && colors.buttons
                        ? colors.buttons
                        : defColors.buttons;
                return c;
            }};
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            .option-img {
                display: ${props => {
                    const parameters = (props && props.parameters) || {};
                    return parameters.image_buttons ? 'flex' : 'none';
                }};
                height: 80%;
                width: 100%;
                align-items: center;
                justify-content: center;
            }

            .option-txt {
                height: 20%;
                font-size: ${props => {
                    const h = props.dimensions.height;
                    return `${parseInt(h * 0.05, 10) || 0}px`;
                }};
            }
        }
    }
`;

export const Model2 = styled.div`
    display: flex;
    height: 100%;

    .header {
        width: 40%;
        height: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: ${props => {
            const { colors, defColors } = props;
            const c =
                colors && colors.buttons ? colors.buttons : defColors.buttons;
            return c;
        }};

        border-bottom: 1px solid #000000aa;

        .pluginbot-logo {
            max-height: 50%;
        }
    }

    .content {
        width: 100%;
        height: 90%;
    }

    .icon-area {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        padding-right: 0px;
    }

    .img-area {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        padding-right: 0px;

        .robot-img {
            max-width: 80%;
            max-height: 60%;
        }

        .pluginspace-logo {
            max-width: 40%;
        }

        .robot-name {
            font-size: ${props => {
                const h = props.dimensions.height;
                return `${parseInt(h * 0.05, 10) || 0}px`;
            }};
        }
    }

    .options-area {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;

        .pluginspace-logo {
            max-width: 90%;
        }

        .pluginbot-logo {
            max-width: 40%;
        }

        .options {
            width: 80%;
        }

        button {
            span {
                font-size: ${props => {
                    const h = props.dimensions.height;
                    return `${parseInt(h * 0.05, 10) || 0}px`;
                }};
            }
        }
    }
`;
